export enum DocumentStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
  PUBLISHED_NOT_LISTED = "published_not_listed",
}
